<template>
  <div>
    <r-title class="title">{{ $t('recovery.password') }}</r-title>
    <p>
      {{ $t('recovery.password.success.text') }}
      <span>{{ email }}</span>
    </p>
    <p class="error">{{ error }}</p>
    <p>
      {{ $t('recovery.password.success.resend') }}
      <a @click="sendEmail">{{ $t('resend') }}</a>
    </p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import RTitle from '@/components/common/Title.vue';
import { RESTORE_PASSWORD_EMAIL } from '@/store/session/actionTypes';

export default {
  components: {
    RTitle,
  },
  data() {
    return {
      email: this.$route.query.email,
      error: '',
    };
  },
  methods: {
    ...mapActions({
      restorePasswordEmail: RESTORE_PASSWORD_EMAIL,
    }),
    async sendEmail() {
      const data = {
        email: this.email,
        message: this.$t('restore.password.email.resent'),
      };

      try {
        await this.restorePasswordEmail(data);
      } catch (error) {
        this.error = error.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/breakpoints';

p {
  text-align: center;
  color: $grey;
}

p:first-of-type {
  margin-bottom: 30px;
}

span {
  color: $dark-grey;
}

a {
  margin-left: 15px;
}

.title {
  text-align: center;
  margin-bottom: 10px;
}

.error {
  color: $red;
  text-align: center;
  padding-bottom: 10px;
}

@media (max-width: $login-base-breakpoint) {
  p {
    font-weight: 100;
  }
}
</style>
